import React, { createContext, useState, useContext } from 'react';
import AuthModal from '../components/auth/AuthModal';

interface AuthContextType {
  isAuthenticated: boolean;
  showAuthModal: boolean;
  openAuthModal: () => void;
  closeAuthModal: () => void;
  signOut: () => void;
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  showAuthModal: false,
  openAuthModal: () => {},
  closeAuthModal: () => {},
  signOut: () => {}
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  const openAuthModal = () => setShowAuthModal(true);
  const closeAuthModal = () => setShowAuthModal(false);
  const signOut = () => setIsAuthenticated(false);

  const handleAuthSuccess = () => {
    setIsAuthenticated(true);
    closeAuthModal();
  };

  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      showAuthModal,
      openAuthModal,
      closeAuthModal,
      signOut
    }}>
      {children}
      <AuthModal 
        isOpen={showAuthModal}
        onClose={closeAuthModal}
        onSuccess={handleAuthSuccess}
      />
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);